module.exports = __webpack_public_path__ + "static/media/adrian_griggs.9f7ef384.png";